import { useEffect, useState } from 'react';

import { getDisplayPrice } from './priceRange';

export const useDisplayPrice = (
  price: number | null | undefined,
  enquiryId: number | null | undefined,
  hasReservePrice = false,
): string | null => {
  const [displayPrice, setDisplayPrice] = useState<string | null>(null);

  useEffect(() => {
    if (hasReservePrice) {
      setDisplayPrice(null);
      return;
    }
    setDisplayPrice(getDisplayPrice(price ?? 0, enquiryId ?? undefined));
  }, [price, enquiryId, hasReservePrice]);

  return displayPrice;
};
